import {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'semantic-ui-react';

export default class SimpleModal extends Component {
  static propTypes = {
    actions: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]),
    className: PropTypes.string,
    content: PropTypes.node,
    trigger: PropTypes.node.isRequired,
    basic: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
  };

  state = {open: false};

  open = () => this.setState({open: true});

  close = () => {
    this.setState({open: false});
    this.props.onClose && this.props.onClose();
  };

  renderActions = () => {
    const {actions} = this.props;
    return actions ? <Modal.Actions>{actions}</Modal.Actions> : null;
  };

  onOpen = () => {
    const {onOpen} = this.props;
    this.open();
    if (onOpen) onOpen();
  };

  render() {
    const {open} = this.state;
    const {basic, content, trigger, className, children} = this.props;

    return (
      <Modal
        className={className}
        trigger={trigger}
        closeIcon
        onClose={this.close}
        open={open}
        onOpen={this.onOpen}
        basic={basic}
      >
        <Modal.Content>
          {content}
          {children}
        </Modal.Content>
        {
          this.renderActions()
        }
      </Modal>
    );
  }
}
